<template>
  <div id="question__container">
    <h1 >{{ msg }}</h1>
    <div id ="point">直感で書いてみよう！</div>
    <div id = "question__box">
      {{ q }}
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'
  export default {
    name: "Question",
    data () {
      return {
        msg: '今日のお題',
        q : ''
      }
    },
    beforeCreate () {
      var database = firebase.database();
      var dataRef = database.ref('/questions');
      dataRef.once("value")
        .then(function(snapshot) {
          var day =　new Date().getDate();
          var r = snapshot.child(String(day)).val();
          document.getElementById('question__box').innerHTML = r;
          var metaDiscre = document.head.children;
          var metaLength = metaDiscre.length;
          for(var i = 0;i < metaLength;i++){
            var proper = metaDiscre[i].getAttribute('property');
            if(proper === 'og:description'){
              var dis = metaDiscre[i];
              dis.setAttribute('content',r);
              document.dispatchEvent(new Event('custom-render-trigger'))
            }
          }
        });
    },
    created() {

    },
  }

</script>

<style scoped>
  #question__container{
    margin: 35px 20px 35px 20px;

  }
  #question__box{
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
    align-items: center; /* 縦方向中央揃え */
    -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
    justify-content: center; /* 横方向中央揃え */
    height: 155px;
    padding: 20px 15px 20px 15px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height:1.5em;
    background: white;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    border-radius: 30px;
  }
  #point{
    margin-bottom: 5px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Question.vue